import { useParams, Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getProductsByCategory } from '@/mocks/products';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import CategorySidebar from './components/CategorySidebar';
import ProductGrid from './components/ProductGrid';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const products = getProductsByCategory(slug || '');

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16 flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
              <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-900 mb-2">分类未找到</h1>
            <p className="text-foreground-500 text-sm mb-4">该分类不存在或已被移除</p>
            <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm font-medium cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const seoTitle = `蜜芽${category.name}｜全球精选母婴好物`;
  const seoDesc = `${category.description.substring(0, 120)}`;
  const seoKeywords = `蜜芽${category.name},母婴${category.name},跨境母婴,蜜芽正品`;
  const canonicalUrl = `https://childcart.github.io/category/${slug}`;

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDesc}
        keywords={seoKeywords}
        canonicalUrl={canonicalUrl}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: seoTitle,
          description: seoDesc,
          url: canonicalUrl,
          isPartOf: { '@type': 'WebSite', name: '蜜芽', url: 'https://childcart.github.io' },
        }}
      />
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="bg-background-50 border-b border-background-200">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '商品分类', href: '/category/milk-powder' },
                { label: category.name },
              ]}
            />
            <div className="px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                {category.name}
              </h1>
              <p className="text-sm text-foreground-600 max-w-2xl">{category.description}</p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="flex flex-col lg:flex-row gap-6">
            <CategorySidebar />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-5">
                <p className="text-sm text-foreground-500">
                  共 <strong className="text-foreground-900">{products.length}</strong> 件商品
                </p>
              </div>
              <ProductGrid products={products} />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}